import { useLayoutEffect } from 'react';

export default function useScrollLock(active) {
  useLayoutEffect(() => {
    if (!active) return undefined;
    const { style } = document.body;
    const previous = { overflow: style.overflow, paddingRight: style.paddingRight };
    const scrollbar = window.innerWidth - document.documentElement.clientWidth;
    style.overflow = 'hidden';
    if (scrollbar > 0) style.paddingRight = `${scrollbar}px`;
    return () => { style.overflow = previous.overflow; style.paddingRight = previous.paddingRight; };
  }, [active]);
}
